import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const RootContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "5px 0",

  "& .MuiIconButton-root": {
    fontSize: "1.1em",
    padding: 8,
  },
});

export const Container = styled(Grid)({
  display: "flex",
  alignItems: "center",
});

export const File = styled(Grid)({
  marginInlineStart: 15,
});
